// extracted by mini-css-extract-plugin
export default {"melodyVideo":"dM-z","isFullWidth":"eM-z","landingPageVideo":"fM-z","play":"gM-z","iframeVideo":"hM-z","playHidden":"iM-z","fullwidth":"jM-z"};